// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

export const StoneRecommendationsNotFoundFragmentDoc = `
    fragment stoneRecommendationsNotFound on StoneRecommendationNotFound {
  __typename
  haveWithoutPricingRange
}
    `;